export default {"src":"/_next/static/media/nextjs.6f547f03.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};